import { Routes } from '@angular/router';
import { PricingComponent } from './component/pricing/pricing.component';
import { Error404Component } from './component/error404/error404.component';
import { Error500Component } from './component/error500/error500.component';
import { SigninComponent } from './component/signin/signin.component';
import { SignupComponent } from './component/signup/signup.component';
import { AuthGuard } from './shared/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./component/landing-page/landing-page.routes').then(
        m => m.landingRoutes
      ),
  },
  {
    path: 'pricing',
    component: PricingComponent,
  },
  {
    path: 'signin',
    component: SigninComponent,
  },
  {
    path: 'signup/:id',
    component: SignupComponent,
  },
  {
    path: '404',
    component: Error404Component,
  },
  {
    path: '**',
    component: Error500Component,
  },
];
